.header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 1.2rem 1.2rem 0 1.2rem;
}
